<template>
	<div>
		<header-section icon="" title="Mis evaluaciones">
			<template slot="buttons">
				<el-button
						size="medium"
						type="danger"
						icon="el-icon-arrow-left"
						@click="$router.push('/inicio')">
					Regresar
				</el-button>
			</template>
		</header-section>
		<el-row>
			<el-col class="tip-3">
				<p>
					Estimado becario(a) recuerda que es muy importante que realices tus evaluaciones mensuales a tu
					tutor(a). Ya que es un requisito para poder efectuar tu depósito de beca.
				</p>
			</el-col>
		</el-row>
		<el-row v-if="showButtonQuiz == true">
			<el-col align="right">
				<el-button type="primary" @click="evaluateTheTutor()">
					<i class="fas fa-user-edit"></i> Evaluar a tutor
				</el-button>
			</el-col>
		</el-row>
		<br/>
		<el-table
				:data="tableData"
				border
				style="width: 100%">
            <!--
			<el-table-column
					min-width="120px"
					align="center"
					label=""
			>
				<template slot-scope="scope">
					<div>
						{{ scope.row.number }}
					</div>
				</template>
			</el-table-column>
            -->
			<el-table-column
					min-width="120px"
					label="Estatus"
			>
				<template slot-scope="scope">
					<div>
						{{ scope.row.status_name }}
					</div>
				</template>

			</el-table-column>
			<el-table-column
					min-width="150px"
					prop="created_at"
					label="Fecha de evaluación">
				<template slot-scope="scope">
					<div>
						{{ scope.row.created_at | formatDate }}
					</div>
				</template>
			</el-table-column>
			<el-table-column
					min-width="240px"
					label="Nombre del responsable">

				<template slot-scope="scope">
					<div>
						{{ scope.row.responsible ? scope.row.responsible.full_name : scope.row.responsibleName }}
					</div>
				</template>
			</el-table-column>
			<el-table-column min-width="240px"  label="Descripción de la evaluación">
				<template slot-scope="scope">
					<div>
						{{ scope.row.evaluation.description ? scope.row.evaluation.description : scope.row.evaluation.description }}
					</div>
				</template>
			</el-table-column>
			<el-table-column
					min-width="220px"
					label="Nombre del plan de capacitación">
				<template slot-scope="scope">
					<div>
						{{ scope.row.people_advisor_training &&
						scope.row.people_advisor_training.advisor_training_plans ?
						scope.row.people_advisor_training.advisor_training_plans.name : scope.row.trainingName }}
					</div>
				</template>
			</el-table-column>
		</el-table>

	</div>
</template>

<script>
	const HeaderSection = _ => import(/* webpackChunkName: "js/split/HeaderSection" */'@/components/partials/HeaderSection');

	export default {

		components: {
			HeaderSection
		},
		data() {
			return {
				tableData: [],
				totalQuizYoungToAdvisor: null,
				loaded: false,
				showButtonQuiz: false

			}
		},
		methods: {
			evaluateTheTutor() {
				this.$router.push('/becario/evaluar-tutor');
			},
			showLoading(msg, showSpinner) {
				this.loading = true;
				if (showSpinner) {
					this.$store.dispatch(
						"loading/spinner",
						{msg: msg, status: true},
						{root: true}
					);
				}
			},
			hideLoading(showSpinner) {
				this.loading = false;
				if (showSpinner) {
					this.$store.dispatch("loading/spinner", {}, {root: true});
				}
			},
			iniService() {
				this.showLoading();
				let params = {};
				let url = '/api/people-advisor/get-all-my-quiz';
				axios.get(`${url}`, {params: params}).then((res) => {
					this.hideLoading();
					this.loaded = true;
					this.tableData = res.data.data;
					this.totalQuizYoungToAdvisor = res.data.totalQuizYoungToAdvisor;
					this.showButtonQuiz = res.data.showButtonQuiz;

				}).catch((err) => {
					this.hideLoading();
					let msg = 'No se pudo completar la acción';
					if (err.response &&
						err.response.data &&
						err.response.data.message
						&& err.response.status == 400) {
						msg = err.response.data.message;
					}
					this.$store.dispatch('notifications/error', {msg: msg}, {root: true});

				});

			}
		},
		created() {
			this.iniService();
		}
	}
</script>

<style scoped>

</style>
